import Tabs from './Tabs';
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';

const defaultRoute = { id: '', label: '', component: <div />, subroutes: [] }

const SplitPanelRouter = forwardRef((props, ref) => {
  const [activeMain, setActiveMain] = useState('');
  const [activeSub, setActiveSub] = useState('');

  useEffect(() => {
    setActiveMain(props.mainActiveRoute);
    setActiveSub(props.subActiveRoute);
  }, [props.mainActiveRoute, props.subActiveRoute])

  // === permettere al punsante indietro nel componente main ===//
  // di poter richiamre resetSubRoutes() e resettare tab della preview
  const resetSubRoutes = () => setActiveSub(getMain(activeMain).subroutes[0].id);;

  useImperativeHandle(ref, () => ({
    resetSubRoutes
  }));
  //=============================================================================//
  
  const getMain = (active) => active ? props.routes.find((route) => route.id === active) : defaultRoute;

  const getSub = (active) => active ?
    props.routes
      .find((route) => route.id === activeMain)
      .subroutes.find((sub) => sub.id === active) : defaultRoute;

  function setActiveTab(id, type) {
    if (type === 'main') {
      const main = getMain(id);
      setActiveMain(main.id);
      setActiveSub(main.subroutes[0].id);
    }
    if (type === 'sub') setActiveSub(getSub(id).id);
  }

  return (
    <main className="split-panel">
      <Tabs
        routes={props.routes}
        active={activeMain}
        setActive={(id) => setActiveTab(id, 'main')}
      >
        {getMain(activeMain).component}
      </Tabs>
      <Tabs
        routes={getMain(activeMain).subroutes}
        active={activeSub}
        setActive={(id) => setActiveTab(id, 'sub')}
      >
        {getSub(activeSub).component}
      </Tabs>
    </main>
  );
});

export default SplitPanelRouter;
